export default {"src":"/_next/static/media/guavas.064f7ad2.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};